export enum SwapProductDialogSteps {
  FINALIZE = 'finalize',
  CHANGE_PRODUCT = 'change-product',
  CHANGE_PATIENT = 'change-patient',
  EDIT_RX = 'edit-rx',
}

export type SwapProductDialogInitialStep = Exclude<
  SwapProductDialogSteps,
  SwapProductDialogSteps.FINALIZE
>
